var map = {
	"./bet-tnc-cn.svg": 2378,
	"./fifa-tnc-cn.svg": 2379,
	"./leaderboard-tnc-cn.svg": 2380,
	"./lucky-tnc-cn.svg": 2381,
	"./term-condition-bm.svg": 2382,
	"./term-condition-cn.svg": 2383,
	"./term-condition-id.svg": 2384,
	"./term-condition.svg": 2385,
	"./term-content.png": 2386,
	"./term-footer.png": 2387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;